import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import BackArrow from '../ui/BackArrow';

const TURRIS_LOGO = '/logo-turris.svg';

export default function PrivacyPolicyScreen() {
  const navigate = useNavigate();

  const goBack = () => {
    navigate(-1);
  };

  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: '#FDFBF7' }}>
      {/* Header */}
      <header className="p-4 sm:p-6 flex items-center justify-between sticky top-0 bg-[#FDFBF7] z-10 border-b border-gray-100">
        <BackArrow onClick={goBack} />
        <img src={TURRIS_LOGO} alt="Turris" className="h-8 sm:h-10" />
        <div className="w-10" />
      </header>

      {/* Content */}
      <main className="flex-1 px-4 sm:px-8 lg:px-16 py-8 max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <h1 
            className="text-3xl sm:text-4xl font-bold mb-8 text-center"
            style={{ color: '#1a365d' }}
          >
            Política de Privacitat
          </h1>

          <div className="prose prose-lg max-w-none" style={{ color: '#333' }}>
            <p className="font-semibold mb-4">
              Turris Panem S.L., d'ara endavant "Turris"
            </p>

            <p className="mb-6 leading-relaxed">
              A Turris volem garantir la privacitat en el tractament de les teves dades personals. 
              A continuació, us expliquem com recopilem, utilitzem i custodiem les dades de les 
              persones que contacten amb nosaltres.
            </p>

            <p className="mb-8 leading-relaxed">
              Turris pot canviar l'actual política per motius d'exigències legislatives o 
              d'autoregulació, per això aconsellem als usuaris que visitin regularment aquest Avís.
            </p>

            <section className="mb-8">
              <h2 className="text-xl font-bold mb-4" style={{ color: '#1a365d' }}>
                I. RESPONSABLE DEL TRACTAMENT
              </h2>
              <p className="mb-4 leading-relaxed">
                L'usuari o client que faciliti a Turris dades de caràcter personal a través de 
                la nostra web o per altres canals (per exemple, xarxes socials) queda informat 
                que el tractament de les seves dades és realitzat per:
              </p>
              <div className="bg-gray-50 p-4 rounded-lg mb-4">
                <p className="font-semibold">TURRIS PANEM, SL</p>
                <p>Carrer Aribau 237, Entresòl 2ª, 08021 Barcelona</p>
                <p>CIF. B-64603194</p>
              </div>
              <p className="mb-4 leading-relaxed">
                Per a dubtes, contactar amb nosaltres a través del següent mail:{' '}
                <a href="mailto:atencio.client@turris.es" className="text-blue-600 hover:underline">
                  atencio.client@turris.es
                </a>
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold mb-4" style={{ color: '#1a365d' }}>
                II. FINALITATS DEL TRACTAMENT DE DADES
              </h2>
              <p className="mb-4 leading-relaxed">
                Vostè, en lliurar espontàniament les seves dades personals amb qualsevol formulari 
                d'aquesta web i acceptar de forma expressa el seu enviament, permet directament a 
                Turris perquè tracti i integri en un fitxer de la seva propietat aquelles dades 
                remeses. La recollida i procés de les dades personals que vostè, com a usuari, 
                faciliti té com a propòsit principal de donar resposta a la consulta i enviar-li 
                informació comercial i/o publicitària. No obstant això, també té com a objectiu 
                les següents accions:
              </p>
              <ul className="list-disc pl-6 mb-4 space-y-2">
                <li>Comunicar amb el remitent de la informació, contestar a la seva sol·licitud, 
                    petició o consulta i coordinar la publicació de consultes i comentaris i fer 
                    un seguiment posterior.</li>
                <li>Dirigir, si escau, la seva comanda i dur a terme la prestació contractada 
                    per l'Usuari, la seva facturació i cobrament.</li>
                <li>Administrar i controlar la cartera de clients.</li>
                <li>Realitzar, si escau, la participació de l'Usuari en sortejos o concursos 
                    organitzats per Turris.</li>
                <li>Portar, si escau, el procés de registre de l'Usuari en la Plataforma Online.</li>
              </ul>
              <p className="mb-4 leading-relaxed">
                En virtut de la Llei 34/2002, d'11 de juliol, de Serveis de la Societat de la 
                Informació i de Comerç Electrònic, en cap concepte Turris enviarà publicitat i 
                comunicacions amb finalitats de venda o unes altres de naturalesa comercial als 
                usuaris sense que intervingui la seva prèvia petició o consentiment. Igualment, 
                tampoc remetrà missatges no sol·licitats ni consentits prèviament ni enviarà 
                cadenes de missatges electrònics no sol·licitats ni prèviament consentits.
              </p>
              <p className="mb-4 leading-relaxed">
                Les dades personals que vostè proporcioni hauran de ser veritables, exactes, 
                complets i actualitzats, responent dels danys i perjudicis que es poguessin 
                generar a causa del no compliment d'aquesta obligació.
              </p>
              <p className="mb-4 leading-relaxed">
                Les dades lliurades per vostè en els camps marcats amb * són obligatoris per a 
                poder complir amb la finalitat exposada en el paràgraf anterior. En el cas que 
                l'usuari no empleni tots els camps sol·licitats, Turris es reserva el dret a 
                dictaminar si prestar a l'usuari el servei de què es tracti.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold mb-4" style={{ color: '#1a365d' }}>
                III. DURACIÓ
              </h2>
              <p className="font-semibold mb-2">Durada del tractament de dades.</p>
              <ul className="list-disc pl-6 mb-4 space-y-3">
                <li>Les dades personals per a la gestió de la relació amb el client i la 
                    facturació i cobrament dels serveis seran conservats mentre es mantingui 
                    la relació contractual vigent. Una vegada finalitzada aquesta relació, 
                    en aquest cas, les dades podran ser conservats durant el temps exigit per 
                    la legislació aplicable i fins que prescriguin les eventuals responsabilitats 
                    derivades del contracte.</li>
                <li>Les dades per a la gestió de preguntes i sol·licituds es conservaran durant 
                    el temps necessari per a donar resposta a aquests, amb un termini màxim d'un any.</li>
                <li>Les dades relatives a publicacions de comentaris sobre els nostres productes 
                    romandran durant la vigència i publicitat dels productes o serveis als quals 
                    fan referència, tret que s'expressi el desig que siguin suprimits en qualsevol moment.</li>
                <li>Les dades per a la participació en concursos, sortejos i promocions es guardaran 
                    durant el temps que durin els mateixos, segons les seves bases específiques, per a 
                    gestionar el seu desenvolupament i, posteriorment, fins que prescriguin les possibles 
                    responsabilitats derivades de la seva execució.</li>
                <li>Les dades per a l'enviament de comunicacions comercials i realització de perfils 
                    comercials dels nostres productes o serveis seran conservats indefinidament fins que, 
                    si escau, ens manifestis la teva voluntat d'esborrar-los.</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold mb-4" style={{ color: '#1a365d' }}>
                IV. DRETS QUE TÉ L'USUARI EN RELACIÓ A LES SEVES DADES
              </h2>
              <p className="mb-4 leading-relaxed">
                L'Usuari pot executar els seus drets d'accés, rectificació, supressió, oposició 
                i decisions individuals automatitzades, portabilitat i limitació del tractament 
                de les seves dades dirigint-se a Turris situada en Carrer Aribau 237, Entresòl 2a, 
                08021 Barcelona, o a l'adreça{' '}
                <a href="mailto:atencio.client@turris.es" className="text-blue-600 hover:underline">
                  atencio.client@turris.es
                </a>
                , proporcionant la documentació que acrediti la identitat de l'interessat. 
                L'Usuari té dret a presentar una reclamació davant l'Agència Espanyola de 
                Protecció de Dades (AEPD), si considera vulnerats els seus drets.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold mb-4" style={{ color: '#1a365d' }}>
                V. LEGITIMACIÓ PER AL TRACTAMENT DE DADES
              </h2>
              <p className="mb-4 leading-relaxed">
                La base legal per a l'ús de dades és l'acceptació expressa de l'interessat.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold mb-4" style={{ color: '#1a365d' }}>
                VI. COMUNICACIÓ DE LES TEVES DADES
              </h2>
              <p className="mb-4 leading-relaxed">
                Amb l'objectiu de concedir la màxima qualitat, Turris necessita compartir les 
                seves Dades Personals amb entitats o proveïdors externs que ens ajuden a poder 
                oferir el millor servei.
              </p>
              <ul className="list-disc pl-6 mb-4 space-y-3">
                <li>Societats que ens ajuden amb diferents qüestions relacionades amb el Servei. 
                    A Turris ens assegurem que tots els nostres proveïdors que poden tenir accés 
                    a les seves Dades Personals actuïn de manera confidencial, lleial i complint 
                    amb tota la normativa aplicable.</li>
                <li>A les entitats financeres a través de les quals es realitzi la gestió de 
                    cobraments i pagaments. A les Administracions públiques competents, en els 
                    casos previstos en la Llei i per a les finalitats en ella descrits.</li>
                <li>A Prestashop, la nostra botiga està allotjada en Prestashop. Aquesta companyia 
                    proveeix la plataforma e-commerce online que ens permet vendre-li els productes 
                    i oferir-li tots els serveis. La seva informació queda recopilada i emmagatzemada 
                    en les bases de dades de Prestashop.</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold mb-4" style={{ color: '#1a365d' }}>
                VII. DADES DE TERCERS
              </h2>
              <p className="mb-4 leading-relaxed">
                Si facilita dades de tercers, assumeix la responsabilitat d'informar-los prèviament 
                de tot el que es preveu en l'article 14 del Reglament General de Protecció de Dades 
                en les condicions establertes en aquest mandat.
              </p>
            </section>

            <section className="mb-8 p-6 rounded-xl" style={{ backgroundColor: '#FEF7E0' }}>
              <h2 className="text-xl font-bold mb-4" style={{ color: '#1a365d' }}>
                ACCEPTACIÓ I CONSENTIMENT
              </h2>
              <p className="leading-relaxed">
                L'Usuari manifesta haver estat informat de les condicions sobre protecció de dades 
                personals, acceptant i consentint el tractament automatitzat dels mateixos per part 
                de Turris, en la forma i per a les finalitats indicades en l'actual Política de Privacitat.
              </p>
            </section>
          </div>
        </motion.div>
      </main>

      {/* Footer */}
      <footer className="py-6 text-center border-t border-gray-100">
        <p className="text-sm" style={{ color: '#666' }}>
          © 2025 Turris Panem S.L. Tots els drets reservats.
        </p>
      </footer>
    </div>
  );
}
